export default "__VITE_ASSET__EO28SWVb__"